var map = {
	"./special-events/thank-you": 1096
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1242;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/pages ^\.\/.*\/thank\-you$
// module id = 1242
// module chunks = 0